import React from "react";
import PropTypes from "prop-types";
//Material imports
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
const Anchor = ({
  text,
  onClick
}) => {
  return /*#__PURE__*/React.createElement(Link, {
    style: {
      cursor: "pointer"
    },
    onClick: onClick
  }, "   ", /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "textPrimary",
    style: {
      fontWeight: "500"
    },
    component: "span"
  }, text));
};
export default Anchor;
Anchor.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func
};